import { Button } from 'foundations-components/transitional/components/Button';
import UIRouterButton from 'ui-addon-react-router-dom/UIRouterButton';
import { jsx as _jsx } from "react/jsx-runtime";
export function HeroButton({
  buttonText,
  buttonUrl,
  onClick
}) {
  const ecosystemUrlPattern = /^https:\/\/ecosystem\.hubspot(qa)?\.com\/marketplace(.*)$/;
  const match = buttonUrl.match(ecosystemUrlPattern);
  if (match) {
    const routerPath = match[2] || '/';
    return /*#__PURE__*/_jsx(UIRouterButton, {
      disabled: false,
      external: false,
      onClick: onClick,
      responsive: true,
      to: routerPath,
      truncate: false,
      type: "button",
      use: "tertiary",
      children: buttonText
    });
  }
  return /*#__PURE__*/_jsx(Button, {
    external: true,
    href: buttonUrl,
    onClick: onClick,
    use: "tertiary",
    children: buttonText
  });
}